<template>
  <div class="po-order">
    <div class="po-order__header">
        <div class="title-l-ls title-l-ls_black">Заказы</div>
        <div class="po-filters _active-box">
            Статус:
            <div
              class="po-filters__item"
              v-for="status in statuses"
              v-bind:key="status.id"
              v-bind:class="{'_active-item _active': status.id == selectedStatus}"
              @click="selectedStatus = status.id"
            >
              {{ status.text }}
            </div>
            <select2 v-bind:options="statuses" v-model.number="selectedStatus">
            </select2>
        </div>
    </div>
    <div class="po-order__table-header">
        <div class="po-order__table-cell po-order__table-cell_1">Состав заказа</div>
        <div class="po-order__table-cell po-order__table-cell_2">Дата</div>
        <div class="po-order__table-cell po-order__table-cell_3">Статус</div>
        <div class="po-order__table-cell">Номер</div>
        <div class="po-order__table-cell po-order__table-cell_5">Общая стоимость</div>
    </div>
    <div class="po-order__list">
      <router-link
      class="po-order-block"
      v-for="order in selectedOrders"
      v-bind:key="order.id"
      :to="{ name: 'order', params: { id: order.id }}">
        <div class="po-order-block__cell po-order-block__cell_icons">
          <img
            class="po-order-block__icon"
            v-for="(icon, index) in order.items_icons"
            v-bind:key="icon + '-' + index"
            v-bind:src="icon"
          >
        </div>
        <div class="po-order-block__cell po-order-block__cell_date">
          {{ order.date | formatDate }}
        </div>
        <div class="po-order-block__cell po-order-block__cell_status">
            <div
              class="po-order-block__status"
              v-bind:class="{
                'po-order-block__status_new': order.status == 1,
                'po-order-block__status_wip': order.status == 2 || order.status == 3,
                'po-order-block__status_done': order.status == 4
              }"
            >
              {{ order.status_name }}
            </div>
        </div>
        <div class="po-order-block__cell po-order-block__cell_num">{{ order.id }}</div>
        <div class="po-order-block__cell po-order-block__cell_price">{{ order.total_cost | splitNumber }} руб</div>
      </router-link>
    </div>
    <div
      class="po-order__buttons"
      v-if="showMore != 0"
    >
        <div
          class="e-button"
          @click="ordersShowed += showMore"
        >
          Показать еще {{ showMore }}
        </div>
        <div
          class="e-button e-button_preview"
          @click="ordersShowed = orders.length"
        >
          Показать все {{ orders.length }}
        </div>
    </div>
  </div>
</template>

<script>

import { Order } from '@/api/order';
import Select2 from '@/components/Select2.vue';

export default {
  name: 'home',
  components: {
    Select2
  },
  data: function() {
    return {
      orders: [],
      selectedStatus: 0,
      ordersShowed: 10,
      statuses: [
        {
          id: 0,
          text: 'Все',
        },
        {
          id: 1,
          text: 'Новый',
        },
        {
          id: 2,
          text: 'В работе',
        },
        {
          id: 3,
          text: 'В обработке',
        },
        {
          id: 4,
          text: 'Выполнен',
        },
      ],
    }
  },
  computed: {
    statusOrders: function() {
      return this.orders.filter(order => {
        return order.status == this.selectedStatus || this.selectedStatus == 0
      });
    },
    selectedOrders: function() {
      return this.statusOrders.slice(0, this.ordersShowed);
    },
    showMore: function() {
      return Math.min(this.statusOrders.length - this.selectedOrders.length, 10);
    }
  },
  mounted: function() {
    Order.orders().then(response => {
        this.orders = response.data;
    });
  },
}
</script>
<style lang="scss">
  .po-order-block__icon {
    width: auto;
    border-radius: 0;
    background-color: transparent;
  }
</style>